import { render } from "./TabsEvent.vue?vue&type=template&id=546f72d9&ts=true"
import script from "./TabsEvent.vue?vue&type=script&lang=ts"
export * from "./TabsEvent.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/levelpro-feed-widget/levelpro-feed-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__